export default "__VITE_ASSET__CML1_14f__"